import App from './app/App.vue';
import {createApp} from "vue";
import {useRouter} from "@/app/providers/AppRouter";
import i18n from "@/app/providers/i18n";
import {createPinia} from 'pinia'
import {vuetify} from "@/app/providers/vuetify";
import {VueQueryPlugin} from '@tanstack/vue-query';
import {createHead} from '@vueuse/head';
import {isProd, isTelecomProd, getApiBaseUrl} from "@/shared/lib/utils/environment";
import {setCookie} from "@/shared/lib/utils/cookie";
import {setUnauthorizedHandler} from "@/shared/api/http";
import {UserModel} from "@/entities/User";
import { Footer, IsmetApps, Logo, installI18nMessages } from '@ismet/vue-ui-kit'

import {scrollOnHover} from '@/app/directives/scrollOnHover';
import RippleDirective from '@/app/directives/ripple';

import '@/app/assets/scss/main.sass';
import '@ismet/vue-ui-kit/dist/vue-ui-kit.css'

import '@/app/assets/scss/template.css';

const router = useRouter()

const appInstance = createApp(App)

const logPath = () => {
    setCookie('lastProjectHref', encodeURIComponent(window.location.href), 24, '/', '.' + getApiBaseUrl())
}

window.addEventListener('popstate', logPath);
window.addEventListener('hashchange', logPath);
window.addEventListener('load', logPath);
document.addEventListener('click', logPath);

if (isProd() || isTelecomProd()) {
    // Sentry грузится отдельным чанком, не блокируя старт приложения
    import('@sentry/vue').then((Sentry) => {
        Sentry.init({
            app: appInstance,
            dsn: "https://ee69571555161a40a4926e434b218d79@sentry.telecom.kz/85",
        });
    });
}

// Сессию не удалось восстановить — разлогиниваем. Вызывается из интерсептора уже после
// app.use(createPinia()), поэтому стор доступен вне компонента.
setUnauthorizedHandler(() => UserModel.useUserStore().logout());

appInstance.directive('scroll-on-hover', scrollOnHover);
appInstance.directive('ripple', RippleDirective);
installI18nMessages(i18n);
appInstance
    .use(createPinia())
    .use(i18n)
    .use(router)
    .use(vuetify)
    .use(VueQueryPlugin, {
        enableDevtoolsV6Plugin: true,
    })
    .use(createHead())
    .mount('#app')
appInstance.component('FooterKit', Footer)
appInstance.component('IsmetApps', IsmetApps)
appInstance.component('LogoKit', Logo)
